import "./bento-box.scss";
import { ReactNode } from "react";

import { BentoBoxColumn, BentoBoxColumnProps } from "./bento-column";

export interface BentoBoxProps {
  bentoBoxColumns: Array<BentoBoxColumnProps>;
  noResultsText?: ReactNode;
}

export function BentoBox({ bentoBoxColumns, noResultsText }: BentoBoxProps) {
  return (
    <div className="hbs-bento-box">
      {bentoBoxColumns.map((bentoBoxColumn, i) => (
        <BentoBoxColumn
          key={i}
          noResultsText={noResultsText}
          {...bentoBoxColumn}
        />
      ))}
    </div>
  );
}
